import React from 'react';
import {
  Spinner,
  FadeWrapper,
  SpinnerWrapper,
  Child,
} from './block-loader.styled';

interface Props {
  children: React.ReactChild;
  show: boolean;
  center?: boolean;
  page?: string; //если у страницы спецефичный состав и нужно особенное поведение
}

/** Обёртка-лоадер, затемняющая обёрнутый блок, блокирующая его функционал и помещающая поверх лоадер **/
export const BlockLoader = React.memo(
  ({ children, show, center, page }: Props) => {
    if (!show) {
      return <>{children}</>;
    }
   
    return (
      <FadeWrapper>
        <SpinnerWrapper center={center}>
          <Spinner />
        </SpinnerWrapper>
        <Child page={page}>{children}</Child>
      </FadeWrapper>
    );
  }
);
